"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.accountProviderActions = exports.initialState = void 0;
const uniqBy_1 = __importDefault(require("lodash/uniqBy"));
const toolkit_1 = require("../../utils/@reduxjs/toolkit");
const api_1 = require("../../utils/api");
const format_1 = require("../../utils/format");
const types_1 = require("./types");
const REDUCER_KEY = 'accountProvider';
exports.initialState = {
    data: {
        user: {
            fetchItem: api_1.requestInitialState, // TODO Apply in general after successful tests
            deleteStatus: api_1.requestInitialState,
        },
        defaultAccount: {
            fetchItem: api_1.requestInitialState,
        },
        virtualGamesTokens: {
            betGames: { fetchItem: api_1.requestInitialState }, // TODO Apply in general after successful tests
            turboGames: { fetchItem: api_1.requestInitialState },
            sportGames: { fetchItem: api_1.requestInitialState },
            cyberbetGames: { fetchItem: api_1.requestInitialState },
            vSportGames: { fetchItem: api_1.requestInitialState },
            liveGames: { fetchItem: api_1.requestInitialState },
            twainGames: { fetchItem: api_1.requestInitialState },
            casino: { fetchItem: api_1.requestInitialState },
            frigg: { fetchItem: api_1.requestInitialState },
        },
        extraData: {
            currentBetsAmount: 0,
            fetchItems: api_1.requestInitialState,
        },
        authentication: {
            stepOneData: {
                firstName: '',
                secondName: '',
                middleName: '',
                email: '',
                iddata: '',
            },
            stepTwoData: {
                controlAnswer: '',
                controlQuestionId: '',
            },
            controlQuestions: [],
            recaptchaToken: '',
            isDisabledBtn: true,
            fetchItem: api_1.requestInitialState,
        },
        changePassword: {
            password: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: '',
            },
            successChange: false,
            recaptchaToken: '',
            isDisabledBtn: true,
            errors: [],
            fetchItem: api_1.requestInitialState,
        },
        bonuses: {
            fetchItem: api_1.requestInitialState,
            items: [],
            hasMore: false,
        },
        loyalty: {
            fetchItem: api_1.requestInitialState,
            items: [],
            filters: {
                currentStatus: types_1.ELoyaltyStatus.ALL,
            },
        },
    },
    layout: {
        typeAuthModal: null,
        authentication: {
            currentStep: null,
        },
        isDisplayTypeformModal: false,
        isSuccessSignUpModal: false,
    },
};
const accountStateSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        setTypeAuthModal(state, action) {
            state.layout.typeAuthModal = action.payload;
        },
        getUser(state, __payload) {
            state.data.user.fetchItem.loading = true;
            state.data.user.fetchItem.error = null;
        },
        getUserSuccess(state, { payload }) {
            state.data.user.entry = payload.user;
            state.data.user.fetchItem.loading = false;
            state.data.user.fetchItem.error = null;
            state.data.user.fetchItem.loaded = true;
        },
        getUserError(state, action) {
            state.data.user.fetchItem.loading = false;
            state.data.user.fetchItem.error = action.payload;
            state.data.user.fetchItem.loaded = true;
        },
        getUserAfterSuccessSignUp() {
            // This reducer is intentionally left empty.
            // It is used only to trigger the getUserAfterSuccessSignUpSaga side-effect.
        },
        resetUser(state) {
            state.data = exports.initialState.data;
        },
        updateBalance(state, { payload: { adjustment, bonusWallet }, }) {
            if (state.data.defaultAccount.entry) {
                if (bonusWallet) {
                    state.data.defaultAccount.entry.bonus += adjustment;
                }
                else {
                    state.data.defaultAccount.entry.balance += adjustment;
                }
            }
        },
        setBalance(state, { payload: { accountUpdate } }) {
            if (state.data.defaultAccount.entry) {
                if (accountUpdate) {
                    state.data.defaultAccount.entry.balance = (0, format_1.adjustAmountForFrontend)(accountUpdate.balance);
                    state.data.defaultAccount.entry.bonus = (0, format_1.adjustAmountForFrontend)(accountUpdate.bonus);
                }
            }
        },
        getDefaultAccount(state) {
            state.data.defaultAccount.fetchItem.loading = true;
            state.data.defaultAccount.fetchItem.error = null;
        },
        getDefaultAccountSuccess(state, { payload: { defaultAccount }, }) {
            state.data.defaultAccount.entry = {
                ...defaultAccount,
                balance: (0, format_1.adjustAmountForFrontend)(defaultAccount.balance),
                bonus: (0, format_1.adjustAmountForFrontend)(defaultAccount.bonus),
            };
            state.data.defaultAccount.fetchItem.loading = false;
            state.data.defaultAccount.fetchItem.error = null;
        },
        getDefaultAccountError(state, action) {
            state.data.defaultAccount.fetchItem.loading = false;
            state.data.defaultAccount.fetchItem.error = action.payload;
        },
        getBetGamesToken(state, _action) {
            state.data.virtualGamesTokens.betGames.fetchItem.loading = true;
            state.data.virtualGamesTokens.betGames.fetchItem.error = null;
        },
        getBetGamesTokenSuccess(state, action) {
            state.data.virtualGamesTokens.betGames.fetchItem.loading = false;
            state.data.virtualGamesTokens.betGames.fetchItem.error = null;
            state.data.virtualGamesTokens.betGames.entry = action.payload.token;
        },
        getBetGamesTokenError(state, action) {
            state.data.virtualGamesTokens.betGames.fetchItem.loading = false;
            state.data.virtualGamesTokens.betGames.fetchItem.error = action.payload;
        },
        resetTurboGames(state) {
            state.data.virtualGamesTokens.turboGames =
                exports.initialState.data.virtualGamesTokens.turboGames;
        },
        getTurboGamesToken(state, _action) {
            state.data.virtualGamesTokens.turboGames.fetchItem.loading = true;
            state.data.virtualGamesTokens.turboGames.fetchItem.error = null;
        },
        getTurboGamesTokenSuccess(state, action) {
            state.data.virtualGamesTokens.turboGames.fetchItem.loading = false;
            state.data.virtualGamesTokens.turboGames.fetchItem.error = null;
            state.data.virtualGamesTokens.turboGames.entry = action.payload.token;
        },
        getTurboGamesTokenError(state, action) {
            state.data.virtualGamesTokens.turboGames.fetchItem.loading = false;
            state.data.virtualGamesTokens.turboGames.fetchItem.error = action.payload;
        },
        getCyberbetToken(state, _action) {
            state.data.virtualGamesTokens.cyberbetGames.fetchItem.loading = true;
            state.data.virtualGamesTokens.cyberbetGames.fetchItem.error = null;
        },
        getCyberbetTokenSuccess(state, { payload }) {
            state.data.virtualGamesTokens.cyberbetGames.fetchItem.loading = false;
            state.data.virtualGamesTokens.cyberbetGames.fetchItem.error = null;
            state.data.virtualGamesTokens.cyberbetGames.entry = payload;
        },
        getCyberbetTokenError(state, { payload }) {
            state.data.virtualGamesTokens.cyberbetGames.fetchItem.loading = false;
            state.data.virtualGamesTokens.cyberbetGames.fetchItem.error = payload;
        },
        getVsportToken(state, _action) {
            state.data.virtualGamesTokens.vSportGames.fetchItem.loading = true;
            state.data.virtualGamesTokens.vSportGames.fetchItem.error = null;
        },
        getVsportTokenSuccess(state, { payload }) {
            state.data.virtualGamesTokens.vSportGames.fetchItem.loading = false;
            state.data.virtualGamesTokens.vSportGames.fetchItem.error = null;
            state.data.virtualGamesTokens.vSportGames.entry = payload;
        },
        getVsportTokenError(state, { payload }) {
            state.data.virtualGamesTokens.vSportGames.fetchItem.loading = false;
            state.data.virtualGamesTokens.vSportGames.fetchItem.error = payload;
        },
        getSportGamesToken(state, _action) {
            state.data.virtualGamesTokens.sportGames.fetchItem.loading = true;
            state.data.virtualGamesTokens.sportGames.fetchItem.error = null;
        },
        getSportGamesTokenSuccess(state, action) {
            state.data.virtualGamesTokens.sportGames.fetchItem.loading = false;
            state.data.virtualGamesTokens.sportGames.fetchItem.error = null;
            state.data.virtualGamesTokens.sportGames.entry = action.payload.token;
        },
        getSportGamesTokenError(state, action) {
            state.data.virtualGamesTokens.sportGames.fetchItem.loading = false;
            state.data.virtualGamesTokens.sportGames.fetchItem.error = action.payload;
        },
        getLiveGamesToken(state, _action) {
            state.data.virtualGamesTokens.liveGames.fetchItem.loading = true;
            state.data.virtualGamesTokens.liveGames.fetchItem.error = null;
        },
        getLiveGamesTokenSuccess(state, action) {
            state.data.virtualGamesTokens.liveGames.fetchItem.loading = false;
            state.data.virtualGamesTokens.liveGames.fetchItem.error = null;
            state.data.virtualGamesTokens.liveGames.entry = action.payload.token;
        },
        getLiveGamesTokenError(state, action) {
            state.data.virtualGamesTokens.liveGames.fetchItem.loading = false;
            state.data.virtualGamesTokens.liveGames.fetchItem.error = action.payload;
        },
        getTwainGamesToken(state, _action) {
            state.data.virtualGamesTokens.twainGames.fetchItem.loading = true;
            state.data.virtualGamesTokens.twainGames.fetchItem.error = null;
        },
        getTwainGamesTokenSuccess(state, action) {
            state.data.virtualGamesTokens.twainGames.fetchItem.loading = false;
            state.data.virtualGamesTokens.twainGames.fetchItem.error = null;
            state.data.virtualGamesTokens.twainGames.entry = action.payload.token;
        },
        getTwainGamesTokenError(state, action) {
            state.data.virtualGamesTokens.twainGames.fetchItem.loading = false;
            state.data.virtualGamesTokens.twainGames.fetchItem.error = action.payload;
        },
        getCasinoToken(state, _action) {
            state.data.virtualGamesTokens.casino.fetchItem.loading = true;
            state.data.virtualGamesTokens.casino.fetchItem.error = null;
        },
        getCasinoTokenSuccess(state, action) {
            state.data.virtualGamesTokens.casino.fetchItem.loading = false;
            state.data.virtualGamesTokens.casino.fetchItem.error = null;
            state.data.virtualGamesTokens.casino.entry = action.payload.token;
        },
        getCasinoTokenError(state, action) {
            state.data.virtualGamesTokens.casino.fetchItem.loading = false;
            state.data.virtualGamesTokens.casino.fetchItem.error = action.payload;
        },
        getFriggToken(state, _action) {
            state.data.virtualGamesTokens.frigg.fetchItem.loading = true;
            state.data.virtualGamesTokens.frigg.fetchItem.error = null;
        },
        getFriggTokenSuccess(state, action) {
            state.data.virtualGamesTokens.frigg.fetchItem.loading = false;
            state.data.virtualGamesTokens.frigg.fetchItem.error = null;
            state.data.virtualGamesTokens.frigg.entry = action.payload.token;
        },
        getFriggTokenError(state, action) {
            state.data.virtualGamesTokens.frigg.fetchItem.loading = false;
            state.data.virtualGamesTokens.frigg.fetchItem.error = action.payload;
        },
        updateAuthenticationDataStepOne(state, { payload }) {
            state.data.authentication.fetchItem.error = null;
            state.data.authentication.stepOneData = {
                ...state.data.authentication.stepOneData,
                ...payload,
            };
            state.layout.authentication.currentStep = types_1.EAuthenticationSteps.TWO;
        },
        updateAuthenticationDataStepTwo(state, { payload }) {
            state.data.authentication.stepTwoData = {
                ...state.data.authentication.stepTwoData,
                ...payload,
            };
        },
        changeAuthenticationCurrentStep(state, { payload: { step } }) {
            state.layout.authentication.currentStep = step;
        },
        fetchSMSCode() { },
        getCurrentBetsAmount(state) {
            state.data.extraData.fetchItems.loading = true;
        },
        getCurrentBetsAmountSuccess(state, { payload: { items } }) {
            state.data.extraData.fetchItems.loading = false;
            const amount = items.reduce((acc, cur) => acc + cur.amount, 0);
            state.data.extraData.currentBetsAmount = (0, format_1.adjustAmountForFrontend)(amount);
        },
        getCurrentBetsAmountError(state, action) {
            state.data.extraData.fetchItems.loading = false;
            state.data.extraData.fetchItems.error = action.payload;
        },
        setChangePassword(state, { payload }) {
            state.data.changePassword.password = {
                ...state.data.changePassword.password,
                ...payload,
            };
        },
        resetChangePassword(state) {
            state.data.changePassword.password =
                exports.initialState.data.changePassword.password;
        },
        setReCaptchaToken(state, { payload }) {
            state.data.changePassword.recaptchaToken = payload;
        },
        setDisabledBtn(state, { payload }) {
            state.data.changePassword.isDisabledBtn = payload;
        },
        fetchChangePassword(state) {
            state.data.changePassword.fetchItem.loading = true;
        },
        fetchChangePasswordSuccess(state, { payload }) {
            state.data.changePassword.recaptchaToken = '';
            state.data.changePassword.errors = [];
            state.data.changePassword.successChange = payload;
        },
        fetchChangePasswordError(state) {
            state.data.changePassword.recaptchaToken = '';
            state.data.changePassword.fetchItem.loading = false;
        },
        getChangePasswordError(state, { payload }) {
            state.data.changePassword.recaptchaToken = '';
            state.data.changePassword.isDisabledBtn = true;
            state.data.changePassword.errors = (0, uniqBy_1.default)(payload, (item) => item.type);
        },
        setValidationErrors(state, { payload }) {
            state.data.changePassword.errors = (0, uniqBy_1.default)(payload, (item) => item.type);
        },
        setAuthenticationReCaptchaToken(state, { payload }) {
            state.data.authentication.recaptchaToken = payload;
            state.data.authentication.isDisabledBtn = false;
        },
        updateCurrentUser(state) {
            state.data.authentication.fetchItem.loading = true;
        },
        updateCurrentUserSuccess(state, { payload }) {
            state.data.user.entry = payload;
            state.data.authentication.recaptchaToken = '';
            state.data.authentication.fetchItem.loading = false;
            state.data.authentication.fetchItem.error = null;
            state.layout.authentication.currentStep = types_1.EAuthenticationSteps.THREE;
        },
        updateUser(state, { payload }) {
            state.data.user.entry = payload;
        },
        updateCurrentUserError(state, { payload }) {
            state.data.authentication.fetchItem.error = payload;
            state.data.authentication.fetchItem.loading = false;
            state.layout.authentication.currentStep = types_1.EAuthenticationSteps.THREE;
        },
        fetchBonuses(state) {
            state.data.bonuses.fetchItem.loading = true;
        },
        setBonuses(state, { payload }) {
            state.data.bonuses.fetchItem.loading = false;
            // TODO to move sorting logic on the backend side
            state.data.bonuses.items = payload.items.reverse();
            state.data.bonuses.hasMore = payload.hasMore;
        },
        getBonusesError(state, { payload }) {
            state.data.bonuses.fetchItem.error = payload;
            state.data.bonuses.fetchItem.loading = false;
        },
        deleteAccount(state) {
            state.data.user.deleteStatus.loading = true;
        },
        deleteAccountSuccess(state) {
            state.data.user.deleteStatus.loading = false;
            state.data.user.deleteStatus.error = undefined;
        },
        deleteAccountError(state, action) {
            state.data.user.deleteStatus.loading = false;
            state.data.user.deleteStatus.error = action.payload;
        },
        closeModalFullRegistration(state) {
            state.layout.authentication.currentStep = null;
        },
        fetchLoyalty(state) {
            state.data.loyalty.fetchItem.loading = true;
        },
        fetchLoyaltySuccess(state, action) {
            state.data.loyalty.fetchItem.loading = false;
            state.data.loyalty.fetchItem.error = undefined;
            state.data.loyalty.items = action.payload.items.map((loyalty) => {
                const { possibleAmount, 
                // eslint-disable-next-line camelcase
                coupon: { amount, currency_restrictions: currencyRestrictions }, } = loyalty;
                return {
                    ...loyalty,
                    possibleAmount: possibleAmount && (0, format_1.adjustAmountForFrontend)(possibleAmount),
                    coupon: {
                        ...loyalty.coupon,
                        amount: (0, format_1.adjustAmountForFrontend)(amount),
                        currency_restrictions: currencyRestrictions === null || currencyRestrictions === void 0 ? void 0 : currencyRestrictions.map((currency) => {
                            var _a;
                            return ({
                                currency_id: currency.currency_id,
                                maxPayout: (0, format_1.adjustAmountForFrontend)((_a = currency.maxPayout) !== null && _a !== void 0 ? _a : 0),
                            });
                        }),
                    },
                };
            });
        },
        fetchLoyaltyError(state, action) {
            state.data.loyalty.fetchItem.loading = false;
            state.data.loyalty.fetchItem.error = action.payload;
        },
        setLoyaltyStatus(state, action) {
            state.data.loyalty.filters.currentStatus = action.payload;
        },
        setIsShowSuccessSignUpModal(state, { payload }) {
            state.layout.isSuccessSignUpModal = payload;
        },
        setIsDisplayTypeformModal(state, { payload }) {
            state.layout.isDisplayTypeformModal = payload;
        },
        fetchControlQuestions(state) {
            state.data.authentication.fetchItem.loading = true;
        },
        setControlQuestions(state, { payload }) {
            state.data.authentication.fetchItem.loading = false;
            state.data.authentication.controlQuestions = payload.items;
        },
    },
});
exports.accountProviderActions = accountStateSlice.actions, exports.reducer = accountStateSlice.reducer, exports.sliceKey = accountStateSlice.name;
//# sourceMappingURL=slice.js.map